type Tone = "neutral" | "info" | "success" | "warning" | "danger" | "accent";

interface Props {
  status: string;
  /** Sobreescritura opcional para tonos custom por entity */
  tone?: Tone;
  /** Etiqueta visible si difiere del status técnico */
  label?: string;
}

const TONE_CLASSES: Record<Tone, string> = {
  neutral: "nx-badge-neutral",
  info: "nx-badge-info",
  success: "nx-badge-success",
  warning: "nx-badge-warning",
  danger: "nx-badge-danger",
  accent: "nx-badge-accent",
};

// Map por defecto que cubre todos los estados de las 4 sub-tabs.
const DEFAULT_MAP: Record<string, { tone: Tone; label: string }> = {
  // producers / artists / providers / jobs
  pending: { tone: "warning", label: "Pendiente" },
  new: { tone: "warning", label: "Nueva" },
  contacted: { tone: "info", label: "Contactado" },
  approved: { tone: "success", label: "Aprobado" },
  verified: { tone: "success", label: "Verificado" },
  featured: { tone: "accent", label: "Destacado" },
  rejected: { tone: "danger", label: "Rechazado" },
  archived: { tone: "neutral", label: "Archivado" },
};

export function StatusBadge({ status, tone, label }: Props) {
  const def = DEFAULT_MAP[status] ?? { tone: "neutral" as Tone, label: status };
  const t = tone ?? def.tone;
  const l = label ?? def.label;
  return <span className={TONE_CLASSES[t]}>{l}</span>;
}
